import { Observable } from 'rxjs';
import { InjectableApi } from '@shared/decorators';
import { ApiService } from '../../shared/services/api.service';
import { ApiResponse } from '@entities/types';

export interface DocumentTypeLookup {
  id: number;
  name: string;
}

@InjectableApi({
  providedIn: 'root',
  baseSegment: 'ats/master/document-types',
})
export class DocumentTypeService extends ApiService {
  getDocumentTypes(): Observable<ApiResponse<DocumentTypeLookup[]>> {
    return this.get('');
  }
}
